import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import type { Breakpoint } from "@/domain/breakpoint";
import type { Season } from "@/domain/schemas";
import { type Clock as ClockSetting, formatLongDate } from "@/domain/time";
import "@/theme/tokens.stylex";
import { colors, sizes, space } from "@/theme/tokens.stylex";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
import { Clock } from "@/ui/Clock";
import { ColorBlock } from "@/ui/ColorBlock";
import { Icon } from "@/ui/Icon";
import { seasonIcons } from "@/ui/seasonIcons";
type TodayHeroProps = {
  season: Season;
  time: Date;
  clock: ClockSetting;
  tz: string;
  breakpoint: Breakpoint;
  weather: ReactNode;
  children: ReactNode;
  xstyle?: stylex.StyleXStyles;
};
const nowPanelType = {
  x138ayyd: "xgeos1r x138ayyd",
  $$css: true
};
const styles = {
  root: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    k7Eaqz: "xeuugli",
    kAzted: "x2lwn1j",
    kVQacm: "x7giv3",
    k9g6sI: "x12h1iku",
    $$css: true
  }
};
export function TodayHero({
  season,
  time,
  clock,
  tz,
  breakpoint,
  weather,
  children,
  xstyle
}: TodayHeroProps) {
  const small = breakpoint === "small";
  return <ColorBlock tone={1} padding="clamp(24px, 2.6vw, 40px)" xstyle={[styles.root, xstyle]}>
      <div {...{
      0: {
        className: "x78zum5 xdt5ytf x1665zp3 xeuugli"
      },
      1: {
        className: "x78zum5 xdt5ytf x1665zp3 xeuugli x7wzq59 x11k3hey"
      }
    }[!!(breakpoint === "normal") << 0]}>
        <div className="xgeos1r x138ayyd x78zum5 xdt5ytf xddi9bj">
          <span className="x78zum5 x6s0dn4 x167g77z xr0iwhn xucc2r2 xlin7pe xwn7fz2 xtvhhri">
            <span>{formatLongDate(time, tz)}</span>
            <Icon icon={seasonIcons[season]} size={18} />
          </span>
          {!small && <Clock time={time} tz={tz} hour12={clock === "12h"} showDate={false} />}
        </div>
        <div {...{
        0: {
          className: "x78zum5 xdt5ytf xeuugli x1p5oq8j x1kmbvj3"
        },
        1: {
          className: "x78zum5 xdt5ytf xeuugli x1kmbvj3 x7beud5"
        }
      }[!!small << 0]}>{weather}</div>
        <div className="x78zum5 xdt5ytf xeuugli x1p5oq8j x1kmbvj3">{children}</div>
      </div>
    </ColorBlock>;
}